module.exports = "/hub/_next/static/assets/3051c0e37ee0fb67eaf9ee271e5da47f.svg";